<template>
  <v-dialog v-model="dialog" max-width="290" retain-focus @keydown.esc="dialog = false">
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip bottom transition="none" color="black">
        <template v-slot:activator="{ on: tooltip }">
          <span v-bind="attrs" v-on="{ ...tooltip, ...dialog }">{{ title }}</span>
        </template>
        <span>Rename</span>
      </v-tooltip>
    </template>
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-card flat tile>
        <v-card-title>Rename</v-card-title>
        <v-card-text>
          <v-text-field ref="name" :label="`Name of ${ capitalize(mode) }`" v-model="title" required @focus="$event.target.select()"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog=false">Cancel</v-btn>
          <v-btn text color="success" @click="onSubmit"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import Files from '@/api/files'
import Datasets from '@/api/datasets'
import Predictions from '@/api/predictions'
import Exports from '@/api/exports'
export default {
  name: 'Rename',
  props: {
    text: { type: String, required: true },
    uuid:   { type: String, required: true },
    mode: { type: String, required: true }
  },
  data () {
    return {
      dialog: false,
      title: null
    }
  },
  created() {
    this.title = this.text
  },
  watch: {
    dialog: function(value) {
      if (value) {
        setTimeout(() => {
          this.$refs.name.focus()
        }, 200)
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.mode == 'file') {
        Files.patch(this.uuid, { name: this.title } ).then( () => {
          this.$emit('rename', this.title)
          this.dialog = false 
        })
      } else if (this.mode == 'dataset') {
        Datasets.patch(this.uuid, { name: this.title } ).then( () => {
          this.$emit('rename', this.title)
          this.dialog = false 
        })
      } else if (this.mode == 'prediction') {
        Predictions.patch(this.uuid, { name: this.title } ).then( () => {
          this.$emit('rename', this.title)
          this.dialog = false 
        })
      } else if (this.mode == 'export') {
        Exports.patch(this.uuid, { name: this.title } ).then( () => {
          this.$emit('rename', this.title)
          this.dialog = false 
        })
      }
    }
  }
}
</script>